module.exports = __webpack_public_path__ + "media/entities/1610-bdfaec58.png";